module.exports = __webpack_public_path__ + "img/dashboard-icon.0ac0af73.png";